const socNetwork = (_arr, _title) => _arr.find((el) => el.title === _title)

export default socNetwork
